import React from 'react';
import { useMatches, Link } from 'react-router-dom';
import { getTranslation, langType } from '../../i18n';

import styles from './breadcrumb.module.css';

const Breadcrumb = ({ translate, lang }) => {
  const matches = useMatches();
  const crumbs = matches
    // first get rid of any matches that don't have handle and crumb
    .filter((match) => Boolean(match.handle?.crumb))
    // now map them into an array of elements, passing the loader
    // data to each one
    .map((match) => ({ crumb: match.handle.crumb(match.data), pathname: match.pathname }));

  const handleTranslation = (crumb) => {
    const { isTranslationKey, content } = crumb.crumb;
    if (isTranslationKey) {
      return translate(content);
    }
    return typeof content !== 'string' ? getTranslation(content, lang) : content;
  };

  return crumbs.length ? (
    <div className={styles.breadcrumb}>
      <ul>
        <li>
          <Link to="/" aria-label={translate('common.toFrontPage')}>
            <span className={`icon--home ${styles.icon}`} />
          </Link>
        </li>
        {crumbs.map((crumb, index) => {
          const isLastElement = index === crumbs.length - 1;
          const content = (
            <span>
              {handleTranslation(crumb)}
            </span>
          );

          return (
            <li key={crumb.pathname}>
              {isLastElement ? content : <Link to={crumb.pathname}>{content}</Link>}
            </li>
          );
        })}
      </ul>
    </div>
  ) : null;
};

Breadcrumb.propTypes = {
  ...langType
};

export default Breadcrumb;
